// Copyright (c) Microsoft. All rights reserved.

import { IChatMessage } from '../../../libs/models/ChatMessage';
import { ISiteInfo } from '../../../libs/models/SelectedSites';
import { ChatScope, ChatState } from './ChatState';

export type Conversations = Record<string, ChatState>;

export interface ConversationsState {
    conversations: Conversations;
    selectedId: string;
    isLoadingMessages: boolean;
}

export const initialState: ConversationsState = {
    conversations: {},
    selectedId: '',
    isLoadingMessages: false
};

export interface UpdateConversationPayload {
    id: string;
    messages: IChatMessage[];
}

export interface ConversationTitleChange {
    id: string;
    newTitle: string;
}

export interface ConversationScopeChange {
    id: string;
    newScope: ChatScope;
}

export interface ConversationSiteSourcesChange {
    id: string;
    siteSources: ISiteInfo[];
}

export interface ConversationHiddenStatusChange {
    id: string;
    newHiddenState: boolean;
}

export interface ConversationInputChange {
    id: string;
    newInput: string;
}

export interface ConversationSystemDescriptionChange {
    id: string;
    newSystemDescription: string;
}